import React from 'react';
import { connect } from 'react-redux';

import { HumanTimeAgo } from '@scripts/utilities/time.js';
import TimeFormat from '@scripts/utilities/time-format.js';

import NotificationImage from '../NotificationImage/index.jsx';
import ArticleTags from '../ArticleTags/index.jsx';
import ArticleBookmark from '../ArticleBookmark/index.jsx';

import { getCurrentTime } from '../../Store/current-time.js';


class ArticleMetadata extends React.Component {
  render() {
    var article = this.props.article;

    var articleType = article.type;
    var authorName = '&nbsp;';
    var authorAvatar = undefined;
    var authorUrl = '';

    var contentClasses = ['cs-article-metadata__content'];

    if (article.author) {
      authorAvatar = article.author.avatar;
      authorName = article.author.name;
      authorUrl = article.author.authorurl;

      if (!article.author.id) {
        contentClasses.push('cs-article-metadata__content--static');
      }
    }

    return (
      <div className="cs-article-metadata row">
        <div className="col-12 col-md-8">
          <a className={contentClasses.join(' ')} href={authorUrl}>
            <div className="cs-article-metadata__avatar">
              <NotificationImage image={authorAvatar} />
            </div>
            <div className="cs-article-metadata__details">
              <div className="cs-article-metadata__author-container">
                <h3
                  className="cs-article-metadata__author-name"
                  dangerouslySetInnerHTML={{ __html: authorName }}
                />
                {this.props.typeHidden ? null : (
                  <span className="cs-article-metadata__article-type">
                    {this.props.setType ? this.props.setType : articleType}
                  </span>
                )}
                {/* shift report badge in the content feed */}
                {this.props.article.shift_report ? (
                  <span className="cs-article-metadata__article-type-shift-report">
                    New Report
                  </span>
                ) : (
                  ''
                )}
              </div>
              <p className="cs-article-metadata__time">
                {HumanTimeAgo(this.props.currentTime - article.timestamp)} <br />
                ({TimeFormat(article.timestamp)})
              </p>
            </div>
          </a>
        </div>

        <div className="col-12 col-md-3">
          {article.tags && <ArticleTags container={this.props.container} tags={article.tags} />}

        </div>
        {article.hasOwnProperty('bookmarks') ? (
        <div className="col col-md px-2 text-right bookmark-position">
          <ArticleBookmark article = {article}/>
        </div>
        ) : ''}
      </div>
    );
  }
}


var mapStateToProps = function(state) {
  return {
    currentTime: getCurrentTime(state)
  };
};


export default connect(mapStateToProps)(ArticleMetadata);

